"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptFailedData = void 0;
class MessageAttemptFailedData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptFailedData.attributeTypeMap;
    }
}
exports.MessageAttemptFailedData = MessageAttemptFailedData;
MessageAttemptFailedData.discriminator = undefined;
MessageAttemptFailedData.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "responseStatusCode",
        "baseName": "responseStatusCode",
        "type": "number",
        "format": "int16"
    },
    {
        "name": "timestamp",
        "baseName": "timestamp",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=MessageAttemptFailedData.js.map